import { type CaptureContext } from '@canvas/input-types';

export const setupClipboardReadPermissions = async (captureContext: CaptureContext) => {
  try {
    if (navigator.permissions) {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-read' as PermissionName,
      });
      captureContext.clipboardReadPermission = permissionStatus.state;
      permissionStatus.onchange = () => {
        captureContext.clipboardReadPermission = permissionStatus.state;
      };
      return permissionStatus;
    } else {
      throw new Error('navigator.permissions is not defined');
    }
  } catch {
    captureContext.clipboardReadPermission = 'unsupported';
  }

  return null;
};

export const setupClipboardWritePermissions = async (captureContext: CaptureContext) => {
  try {
    if (navigator.permissions) {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-write' as PermissionName,
      });

      captureContext.clipboardWritePermission = permissionStatus.state;
      permissionStatus.onchange = () => {
        captureContext.clipboardWritePermission = permissionStatus.state;
      };
      return permissionStatus;
    } else {
      throw new Error('navigator.permissions is not defined');
    }
  } catch {
    captureContext.clipboardWritePermission = 'unsupported';
  }

  return null;
};

export const setupClipboardPermissions = (captureContext: CaptureContext) => {
  let readPermissionStatus: PermissionStatus | null = null;
  let writePermissionStatus: PermissionStatus | null = null;

  Promise.all([
    setupClipboardReadPermissions(captureContext),
    setupClipboardWritePermissions(captureContext),
  ]).then(([readPermissionStatusNew, writePermissionStatusNew]) => {
    readPermissionStatus = readPermissionStatusNew;
    writePermissionStatus = writePermissionStatusNew;
  });

  return () => {
    if (readPermissionStatus) {
      readPermissionStatus.onchange = null;
    }
    if (writePermissionStatus) {
      writePermissionStatus.onchange = null;
    }
  };
};
